import { Outlet, Navigate } from 'react-router-dom'
import { useAppSelector } from './store/hooks'

function AdminRoute() {
  const { token, account } = useAppSelector((state) => state.currentUser)
  return token && account?.isSuperuser ? <Outlet /> : <Navigate to="/login" />
}

export default AdminRoute
